let swiperPtsKeleCar;
async function initSlideKeleCar(collUrl = null) {
  const prodslideel = document.querySelector(
    ".product-carousel-section .product-carousel"
  );
  let slideEl = prodslideel.querySelector(".product-carousel__wrapper");
  let slides = prodslideel.querySelectorAll(".swiper-slide__prod");
  let carousel = prodslideel.querySelector(".swiper-carousel");
  let buttonNext = prodslideel.querySelector(".swiper-button-next");
  let prodCountHalf = parseFloat(slideEl.getAttribute("data-count")) + 0.1;
  let loading = prodslideel.querySelector(".pts-loading");
  if (collUrl) {
    loading.classList.add("show");
  }
  slides.forEach((slide) => {
    slide.classList.add("swiper-slide");
  });
  try {
    let tsEl = prodslideel.querySelector(".swiper-container");
    let tsSwEl = tsEl.querySelector(".swiper-wrapper");
    if (collUrl) {
      let req = await fetch(collUrl);
      let html = await req.text();
      if (swiperPtsKeleCar) {
        swiperPtsKeleCar.destroy(true, true)
        swiperPtsKeleCar = undefined;
        slides.forEach((slide) => {
          slide.removeAttribute("style");
          slide.classList.remove("swiper-slide");
        });
      }
      let domPts = html;
      tsSwEl.innerHTML = domPts;
      tsEl.style.opacity = 0;
    }
    swiperPtsKeleCar = new Swiper(
      ".product-carousel-section .product-carousel .swiper-container",
      {
        centeredSlides: false,
        slidesPerView: 1.18,
        waitForTransition: false,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        preloadImages: true,
        allowTouchMove: true,
        spaceBetween: 4,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        breakpoints: {
          576: {
            slidesPerView: 1.18,
            slidesOffsetBefore: 32,
            slidesOffsetAfter: 32,		
          },
          768: {
            slidesPerView: 1.1,
            slidesOffsetBefore: 32,
            slidesOffsetAfter: 32,		
          },
          990: {
            slidesPerView: 2.18,
            slidesOffsetBefore: 32,
            slidesOffsetAfter: 32,	
          },
          1200: {
            slidesPerView: 3.18,
            slidesOffsetBefore: 32,
            slidesOffsetAfter: 32,	
          },
          1360: {
            slidesPerView: 3.18,
            slidesOffsetBefore: 64,
            slidesOffsetAfter: 64,	
          },
        },
        navigation: {
          nextEl: `.product-carousel-section .product-carousel .swiper-button-next__prod`,
          prevEl: `.product-carousel-section .product-carousel .swiper-button-prev__prod`,
        },
        on: {
          init: function () {
            setTimeout(function () {
              loading.classList.remove("show");
              tsEl.style.opacity = 1;
            }, 500);
          },
        },
      }
    );
  } catch (error) {
    console.log(error);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initSlideKeleCar();
});
document.addEventListener("shopify:section:load", function () {
  initSlideKeleCar();
});

//button-with-underline
if (window.screen.width > 990) {
  let attachedProductCarousel = false;

  let carouselSection = document.querySelector(".product-carousel-section");

  let imageContainerCarousel = carouselSection.querySelector(
    ".button--with-underline--container"
  );

  let followMouseCarousel = (event) => {
    if (imageContainerCarousel) {
      imageContainerCarousel.style.left = event.pageX + "px";
      imageContainerCarousel.style.top = event.pageY + 30 + "px";
    }
  };

  function showTextCarousel() {
    if (!attachedProductCarousel && imageContainerCarousel) {
      attachedProductCarousel = true;
      imageContainerCarousel.style.display = "block";
      document.addEventListener("pointermove", followMouseCarousel);
    }
  }

  function hideTextCarousel() {
    if (imageContainerCarousel) {
      attachedProductCarousel = false;
      imageContainerCarousel.style.display = "";
      document.removeEventListener("pointermove", followMouseCarousel);
    }
  }
}

let tabItem = document.querySelectorAll(".product-carousel__btns a");
tabItem.forEach(function (ti) {
  ti.addEventListener("click", function (e) {
    e.preventDefault();
    let el = e.target;
    let collUrl = el.getAttribute("href");
    tabItem.forEach(function (theTi) {
      theTi.classList.remove("active");
    });
    initSlideKeleCar(collUrl);
    el.classList.add("active");
  });
});
